var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tinymce-editor',{attrs:{"init":_vm.tinymceSettings,"value":_vm.value},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }